import { useEffect, useState } from 'react';

import lang from '../../../../../lib/language';

import { useIsMobile, useSubPageTitle } from '../../../../../hooks';
import Grid from '../../../../Grid/Grid';
import { GoBackButton, Preloader } from '../../../../index';

import PersonalDetailsComponent from './components/personalDetailsComponent/PersonalDetailsComponent';

import styles from './PersonalDetails.module.scss';

const PersonalDetails = () => {
  const { isMobile } = useIsMobile();
  const titleRef = useSubPageTitle<HTMLDivElement>();

  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <Grid>
      <div className={styles.wrapper}>
        {!isMobile && <GoBackButton />}
        <div ref={titleRef} className={styles.title}>{lang.myProfilePersonalDetails()}</div>
        {loading ? (
          <div className={styles.loader}><Preloader owner="Personal Details" text="" /></div>
        ) : (
          <PersonalDetailsComponent />
        )}
      </div>
    </Grid>
  );
};

export default PersonalDetails;
